import AllProspects from "./allProspects";

export default AllProspects;
